"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const IC_X_1 = __importDefault(require("../../assets/icons/IC_X"));
const IconHistory_1 = __importDefault(require("../../assets/icons/IconHistory"));
const IconPost_1 = __importDefault(require("../../assets/icons/IconPost"));
const IconTimeLine_1 = __importDefault(require("../../assets/icons/IconTimeLine"));
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const rootNavigation_1 = require("../../navigators/rootNavigation");
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalAddPost = (props) => {
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const { onClose, visible } = props;
    const { width: _width, height } = react_native_1.Dimensions.get('window');
    const width = react_native_1.Platform.OS === 'web' ? (_width >= 1024 ? 375 : _width) : _width;
    const translateY = (0, react_1.useRef)(new react_native_1.Animated.Value(0)).current;
    (0, react_1.useEffect)(() => {
        if (visible) {
            react_native_1.Animated.timing(translateY, {
                toValue: 1,
                duration: 300,
                useNativeDriver: false,
            }).start();
        }
    }, [visible]);
    const closeModal = () => {
        react_native_1.Animated.timing(translateY, {
            toValue: 0,
            duration: 300,
            useNativeDriver: false,
        }).start(() => onClose());
    };
    return (react_1.default.createElement(react_native_1.Modal, { statusBarTranslucent: true, visible: visible, animationType: "fade", transparent: true, onRequestClose: closeModal, ...props, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        } },
        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: closeModal, activeOpacity: 1, style: {
                flex: 1,
                backgroundColor: Colors_1.default.textHeaderOpacity60,
                justifyContent: 'flex-end',
                alignItems: 'center',
            } },
            react_1.default.createElement(react_native_1.Animated.View, { style: [
                    {
                        backgroundColor: 'white',
                        width: width,
                        position: 'absolute',
                        paddingBottom: insets.bottom + 10,
                        paddingTop: 10,
                        borderTopLeftRadius: (0, scale_1.scale)(16),
                        borderTopRightRadius: (0, scale_1.scale)(16),
                        paddingHorizontal: (0, scale_1.scale)(20),
                        ...react_native_1.Platform.select({
                            web: {
                                maxWidth: width,
                            },
                        }),
                    },
                    {
                        transform: [
                            {
                                translateY: translateY.interpolate({
                                    inputRange: [0, 1],
                                    outputRange: [500, 0],
                                }),
                            },
                        ],
                    },
                ] },
                react_1.default.createElement(react_native_1.View, { style: {
                        flexDirection: 'row',
                        borderLeftWidth: 6,
                        borderLeftColor: '#287BCF',
                        marginTop: (0, scale_1.verticalScale)(20),
                        paddingLeft: (0, scale_1.scale)(8),
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    } },
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(16),
                            color: Colors_1.default.textHeader,
                            fontWeight: '300',
                            lineHeight: (0, scale_1.moderateScale)(24),
                        } }, "\u30E1\u30CB\u30E5\u30FC\u9078\u629E"),
                    react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: closeModal },
                        react_1.default.createElement(IC_X_1.default, { color: '#888888' }))),
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                        flexDirection: 'row',
                        marginTop: (0, scale_1.scale)(16),
                        alignItems: 'center',
                    }, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_POST, { data: null, type: 'POST' });
                        onClose();
                    } },
                    react_1.default.createElement(react_native_1.View, { style: {
                            height: (0, scale_1.scale)(32),
                            width: (0, scale_1.scale)(32),
                            borderRadius: (0, scale_1.scale)(5),
                            backgroundColor: '#287BCF',
                            justifyContent: 'center',
                            alignItems: 'center',
                        } },
                        react_1.default.createElement(IconTimeLine_1.default, null)),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontWeight: '300',
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            marginLeft: (0, scale_1.scale)(18),
                        } }, "\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u6295\u7A3F")),
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                        flexDirection: 'row',
                        marginTop: (0, scale_1.scale)(16),
                        alignItems: 'center',
                    }, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_ARTICLE, { content_type: 1 });
                        onClose();
                    } },
                    react_1.default.createElement(react_native_1.View, { style: {
                            height: (0, scale_1.scale)(32),
                            width: (0, scale_1.scale)(32),
                            borderRadius: (0, scale_1.scale)(5),
                            backgroundColor: '#287BCF',
                            justifyContent: 'center',
                            alignItems: 'center',
                        } },
                        react_1.default.createElement(IconPost_1.default, null)),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontWeight: '300',
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            marginLeft: (0, scale_1.scale)(18),
                        } }, "\u8A18\u4E8B\u4F5C\u6210")),
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                        flexDirection: 'row',
                        marginTop: (0, scale_1.scale)(16),
                        alignItems: 'center',
                    }, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_ARTICLE, { content_type: 2 });
                        onClose();
                    } },
                    react_1.default.createElement(react_native_1.View, { style: {
                            height: (0, scale_1.scale)(32),
                            width: (0, scale_1.scale)(32),
                            borderRadius: (0, scale_1.scale)(5),
                            backgroundColor: '#287BCF',
                            justifyContent: 'center',
                            alignItems: 'center',
                        } },
                        react_1.default.createElement(IconHistory_1.default, null)),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontWeight: '300',
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            marginLeft: (0, scale_1.scale)(18),
                        } }, "\u81EA\u5206\u53F2\u4F5C\u6210"))))));
};
exports.default = ModalAddPost;
